<template>
  <Panel header="Calendario">
    <Toolbar class="mb-4">
      <template #start>
        <Button
          label="Solicitar Agendamento"
          icon="pi pi-plus"
          class="mr-2"
          @click="showCreate()"
        />
      </template>
      <template #end>
        <Button
          label="Pesquisar Evento"
          icon="pi pi-search"
          class="p-button-success mr-2"
          @click="showSearch()"
        />
      </template>
    </Toolbar>
    <div v-if="loading" class="text-center">
      <ProgressBar mode="indeterminate" style="height: 6px"></ProgressBar>
      <h3>Buscando Eventos...</h3>
    </div>
    <div v-else>
      <FullCalendar :options="calendarOptions" style="cursor: pointer" />
    </div>
  </Panel>
  <dialog-details :objSelected="eventSelected" />
  <dialog-search-vue @showDetails="showDetails" />
  <dialog-requested-events @findAll="findAllCalendars" />
</template>

<script>
//Components
import FullCalendar from "@fullcalendar/vue3";
import dayGridPlugin from "@fullcalendar/daygrid";
import interactionPlugin from "@fullcalendar/interaction";
import timeGridPlugin from "@fullcalendar/timegrid";
import localeBR from "@fullcalendar/core/locales/pt-br";
import DialogDetails from "./components/dialog-details.vue";
import DialogSearchVue from "./components/dialog-search.vue";
import DialogRequestedEvents from "./components/dialog-requested-events.vue";

//Services
import EventService from "../../service/internal/event/event_service";
import ResponsibleService from "../../service/internal/responsible/responsible_service";
//Models
import Calendar from "../../models/internal/calendar";
import Event from "../../models/internal/event";
import Responsible from "../../models/internal/responsible";

export default {
  components: {
    FullCalendar,
    DialogDetails,
    DialogSearchVue,
    DialogRequestedEvents,
  },
  data() {
    return {
      loading: false,
      user: null,
      clickedEvent: null,
      changedEvent: { title: "", start: null, end: "" },
      service: new EventService(),
      responsibleService: new ResponsibleService(),
      events: [],
      eventSelected: new Event(),
      calendars: [],
      calendar: new Calendar(),
      initDate: this.$DateTime.getInitMonthDay(),
      endDate: this.$DateTime.getEndMonthDay(),
      calendarOptions: {
        plugins: [dayGridPlugin, timeGridPlugin, interactionPlugin],
        timeZone: "America/Belem",
        defaultDate: new Date(),
        editable: false,
        locale: localeBR,
        initialView: "dayGridMonth",
        dayHeaderFormat: { weekday: "long" },
        //showNonCurrentDates: false,
        datesSet: (e) => {
          this.initDate = this.$DateTime.formatarDateInput(e.start);
          this.endDate = this.$DateTime.formatarDateInput(e.end);
          this.findAllCalendars();
        },
        eventClick: (e) => {
          this.clickedEvent = e.event;
          this.calendar = this.calendars.filter((calendar) => {
            if (this.clickedEvent.id == calendar.id) return calendar;
          })[0];
          this.eventSelected = this.events.filter((e) => {
            if (this.calendar.eventId == e.id) return e;
          })[0];
          this.findPerson();
          this.$store.state.views.event.dialogDetails = true;
        },
        events: [],
        //eventColor: "#378006",
      },
    };
  },
  created() {
    if (this.$Token.getCookie("access_token")) {
      this.user = this.$store.getters.getUserLogged;
      this.findAllEvents();
      this.findAllCalendars();
      this.addCustomButtons();
    } else {
      this.$toast.add({
        severity: "warn",
        summary: "Atenção!",
        detail: "Usuário desconectado! Você precisa fazer login novamente",
        life: 6000,
      });
      window.location.replace(this.$UrlIntranet);
    }
  },
  methods: {
    showDetails(e) {
      this.eventSelected = e;
      this.findPerson();
      this.$store.state.views.event.dialogDetails = true;
    },
    findPerson() {
      this.responsibleService
        .findById(this.eventSelected.responsible.id)
        .then((res) => {
          this.eventSelected.responsible = new Responsible(res);
        });
    },
    findAllEvents() {
      this.service.findAllEvents().then((data) => {
        this.events = data.content;
        if (
          this.events.find((element) => element.status == "REQUESTED") &&
          this.checkGroupPermission("ADMINISTRADOR_EVENTOS")
        ) {
          this.$store.state.views.event.dialogRequesteds = true;
        }
      });
    },
    findAllCalendars() {
      this.service.getEventsByDate(this.initDate, this.endDate).then((data) => {
        this.calendars = [];
        this.events = data;
        data.map((event) => {
          event.calendars.map((calendar) => {
            calendar.title = event.name;
            calendar.initTime = `${calendar.date} ${calendar.initTime}`;
            calendar.endTime = `${calendar.date} ${calendar.endTime}`;
            calendar.eventId = event.id;
            calendar.status = event.status;
            if (
              event.status == "REQUESTED" &&
              this.checkGroupPermission("ADMINISTRADOR_EVENTOS")
            ) {
              calendar.borderColor = "#feedaf";
              calendar.backgroundColor = "#feedaf";
              calendar.textColor = "#8a5340";
              this.calendars.push(calendar);
            } else if (event.status == "SCHEDULE") {
              calendar.backgroundColor = "#0274d891";
              calendar.borderColor = "#ffffff";
              this.calendars.push(calendar);
            } else if (event.status == "FINISHED") {
              calendar.borderColor = "#c8e6c9";
              calendar.backgroundColor = "#c8e6c9";
              calendar.textColor = "#256029";
              this.calendars.push(calendar);
            }
          });
        });
        this.calendarOptions.events = this.calendars;
      });
    },
    findAllRequestedEvents() {
      this.calendarOptions.events = this.calendars;
      this.calendarOptions.events = this.calendarOptions.events.filter(
        (calendar) => calendar.status === "REQUESTED"
      );
    },
    findAllScheduledEvents() {
      this.calendarOptions.events = this.calendars;
      this.calendarOptions.events = this.calendarOptions.events.filter(
        (calendar) => calendar.status === "SCHEDULE"
      );
    },
    findAllFinishedEvents() {
      this.calendarOptions.events = this.calendars;
      this.calendarOptions.events = this.calendarOptions.events.filter(
        (calendar) => calendar.status === "FINISHED"
      );
    },
    // findAllRequestedEvents() {
    //   this.service
    //     .searchByStatusOrName(`status=REQUESTED&name=""`)
    //     .then((data) => {
    //       this.calendars = [];
    //       data.map((element) => {
    //         element.calendars.map((calendar) => {
    //           calendar.title = element.name;
    //           calendar.initTime = `${calendar.date} ${calendar.initTime}`;
    //           calendar.endTime = `${calendar.date} ${calendar.endTime}`;
    //           calendar.eventId = element.id;
    //           calendar.borderColor = "#feedaf";
    //           calendar.backgroundColor = "#feedaf";
    //           calendar.textColor = "#8a5340";
    //           this.calendars.push(calendar);
    //         });
    //       });
    //       this.calendarOptions.events = this.calendars;
    //     });
    // },
    // findAllScheduledEvents() {
    //   this.service
    //     .searchByStatusOrName(`status=SCHEDULE&name=""`)
    //     .then((data) => {
    //       this.calendars = [];
    //       data.map((element) => {
    //         element.calendars.map((calendar) => {
    //           calendar.title = element.name;
    //           calendar.initTime = `${calendar.date} ${calendar.initTime}`;
    //           calendar.endTime = `${calendar.date} ${calendar.endTime}`;
    //           calendar.eventId = element.id;
    //           calendar.borderColor = "#0274d891";
    //           calendar.backgroundColor = "#0274d891";
    //           this.calendars.push(calendar);
    //         });
    //       });
    //       this.calendarOptions.events = this.calendars;
    //     });
    // },
    // findAllFinishedEvents() {
    //   this.service
    //     .searchByStatusOrName(`status=FINISHED&name=""`)
    //     .then((data) => {
    //       this.calendars = [];
    //       data.map((element) => {
    //         element.calendars.map((calendar) => {
    //           calendar.title = element.name;
    //           calendar.initTime = `${calendar.date} ${calendar.initTime}`;
    //           calendar.endTime = `${calendar.date} ${calendar.endTime}`;
    //           calendar.eventId = element.id;
    //           calendar.borderColor = "#c8e6c9";
    //           calendar.backgroundColor = "#c8e6c9";
    //           calendar.textColor = "#256029";
    //           this.calendars.push(calendar);
    //         });
    //       });
    //       this.calendarOptions.events = this.calendars;
    //     });
    // },
    showCreate() {
      this.$router.push("/agendamento");
    },
    showSearch() {
      this.$store.state.views.calendar.dialogSearch = true;
    },
    checkGroupPermission(p) {
      if (this.user.services) {
        let isPermited = this.user.services.filter(
          (a) => a.groupPermission == p
        );
        return isPermited.length > 0;
      } else {
        return false;
      }
    },
    addCustomButtons() {
      if (this.checkGroupPermission("ADMINISTRADOR_EVENTOS")) {
        (this.calendarOptions.headerToolbar = {
          start: "buttonTodos,buttonSolicitado,buttonAgendado,buttonFinalizado",
          center: "title",
          right: "dayGridMonth,timeGridWeek prevYear,prev,next,nextYear",
        }),
          (this.calendarOptions.customButtons = {
            buttonTodos: {
              text: "Todos",
              click: () => this.findAllCalendars(),
            },
            buttonSolicitado: {
              text: "Solicitados",
              click: () => this.findAllRequestedEvents(),
            },
            buttonAgendado: {
              text: "Agendados",
              click: () => this.findAllScheduledEvents(),
            },
            buttonFinalizado: {
              text: "Finalizados",
              click: () => this.findAllFinishedEvents(),
            },
          });
      } else {
        (this.calendarOptions.headerToolbar = {
          start: "buttonTodos,buttonAgendado,buttonFinalizado",
          center: "title",
          right: "dayGridMonth,timeGridWeek prevYear,prev,next,nextYear",
        }),
          (this.calendarOptions.customButtons = {
            buttonTodos: {
              text: "Todos",
              click: () => this.findAllCalendars(),
            },
            buttonAgendado: {
              text: "Agendados",
              click: () => this.findAllScheduledEvents(),
            },
            buttonFinalizado: {
              text: "Finalizados",
              click: () => this.findAllFinishedEvents(),
            },
          });
      }
    },
  },
};
</script>

<style lang="scss" scoped>
@import url("../../App.scss");
</style>
